<template>
  <div class="header-logo__wrapper">
    <a-icon
      :to="$options.consts.MAIN_ROUTE"
      :icon="$options.consts.ICON.FM_AWARDS_LOGO"
      :no-hover="true"
      :original="true"
      width="auto"
      height="auto"
      aria-label="FM awards homepage"
      class="header-logo__logo"
    />
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { MAIN_ROUTE } from 'enums/main-route'

export default {
  name: 'AHeaderLogo',
  components: { AIcon },
  consts: {
    ICON,
    MAIN_ROUTE
  }
}
</script>

<style lang="scss" scoped>
.header-logo__wrapper {
  // do not remove: fix for old safari (12)
  display: flex;
  justify-content: center;
  align-items: center;

  $width: (
    $above-desktop-xl: 174px,
    $tablet: 146px,
    $mobile: 137px
  );

  $height: (
    $above-desktop-xl: 38px,
    $tablet: 32px,
    $mobile: 30px
  );

  @include setStyleByBreakpoint('width', $width);
  @include setStyleByBreakpoint('height', $height);

  .header-logo__logo {
    // do not remove: fix for old safari (12)
    width: 100%;
  }
}
</style>
